import React, { useCallback, ChangeEventHandler } from 'react';

interface UniversalFilterTextInputProps {
  value: string;
  autoFocus?: boolean;
  onChange: (value?: string) => void;
}

function UniversalFilterTextInput({
  value,
  autoFocus,
  onChange
}: UniversalFilterTextInputProps) {
  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (event) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <div className="flex-1">
      <div className="relative">
        <input
          className="basic-input"
          type="text"
          value={value || ''}
          autoFocus={autoFocus}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}

export default UniversalFilterTextInput;
